module.exports = __webpack_public_path__ + "img/chatbot-banner.31c1444.png";